// extracted by mini-css-extract-plugin
export default {"loaderWrapper":"style_loaderWrapper__OTJT0","hidden":"style_hidden__fFqx6","lds_ripple":"style_lds_ripple__dDWvb"};